import { Component, EventEmitter, input, Input, output, Output } from '@angular/core';
import { AppUserMenuService } from 'src/app/app-service/app-user-menu.service';


@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    standalone: false
})
export class AppAccountComponent{
  isLogOut = output<boolean>();
  username = input('Guest');
  constructor(
    public menuService: AppUserMenuService) {}
  signOut() {
    this.isLogOut.emit(true);
  }
}
